import React from 'react';
import { useUnistyles } from 'react-native-unistyles';

const SpacerBlock = ({ block, isSelected, onSelect }) => {
    const { theme: { colors, fonts } } = useUnistyles();
    const { content, styles: blockStyles } = block;

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                position: 'relative',
                height: `${content.height || 20}px`,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
            }}
        >
            {isSelected && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: 11,
                    color: colors.textTertiary,
                    fontFamily: fonts.body,
                    pointerEvents: 'none',
                    whiteSpace: 'nowrap',
                }}>
                    Spacer — {content.height || 20}px
                </div>
            )}
        </div>
    );
};

export default SpacerBlock;
